import { gql } from '@apollo/client'

export const FIND_EXTENSION_CONFIG = gql`
  query findExtensionConfig {
    findExtensionConfig {
      status
      message
    }
  }
`

export const UPDATE_EXTENSION_CONFIG = gql`
  mutation updateExtensionConfig($params: UpdateExtensionInput!) {
    updateExtensionConfig(updateExtensionInputFieldName: $params) {
      status
      message
    }
  }
`

export const FIND_ALL_EXTENSION_EXAMS = gql`
  query findAllExtensionExams($query: ExtensionExamQueryInput!) {
    findAllExtensionExam(query: $query) {
      items {
        id
        title
        examId
        contentPackageId
        showSolution
        showExam
        message
        extensionExamSection {
          id
          title
          order
          sectionId
          showSolution
          questionCount
          solutionCount
        }
      }
      count
    }
  }
`

export const QUESTION_FIELDS = gql`
  fragment ExtensionQuestionFields on ExtensionQuestionType {
    id
    order
    question
    optionsCount
    correctOption
    answer
    mainSolution
    mainVideoSolution
    answerSolution
    questionId
    passageId
    history {
      updatedAt
      updatedBy
    }
  }
`

export const FIND_ONE_EXTENSION_EXAM_SECTION = gql`
  ${QUESTION_FIELDS}
  query findOneExtensionExamSection($id: String!) {
    findOneExtensionExamSection(id: $id) {
      id
      title
      order
      sectionId
      showSolution
      extensionExam {
        id
        title
        examId
        showSolution
      }
      extensionPassage {
        id
        content
        passageId
        videoWalkthrough
        extensionQuestion {
          ...ExtensionQuestionFields
        }
      }
      extensionQuestion {
        ...ExtensionQuestionFields
      }
    }
  }
`

export const UPDATE_EXTENSION_EXAM = gql`
  mutation updateExtensionExam($params: UpdateExtensionExamInput!) {
    updateExtensionExam(updateExtensionExamInputFieldName: $params) {
      id
      showSolution
      showExam
      message
    }
  }
`

export const UPDATE_EXTENSION_EXAM_SECTION = gql`
  mutation updateExtensionExamSection($params: UpdateExtensionExamSectionInput!) {
    updateExtensionExamSection(updateExtensionExamSectionInputFieldName: $params) {
      id
      showSolution
    }
  }
`

export const UPDATE_EXTENSION_EXAM_PASSAGE = gql`
  mutation updateExtensionPassage($params: UpdateExtensionPassageInput!) {
    updateExtensionPassage(updateExtensionPassageInputFieldName: $params) {
      id
      videoWalkthrough
    }
  }
`

export const UPDATE_EXTENSION_EXAM_QUESTION = gql`
  mutation updateExtensionQuestion($params: UpdateExtensionQuestionInput!) {
    updateExtensionQuestion(updateExtensionQuestionInputFieldName: $params) {
      id
      mainSolution
      mainVideoSolution
      answerSolution
    }
  }
`
